import { render } from "./PackagePage.vue?vue&type=template&id=209206fa&scoped=true"
import script from "./PackagePage.vue?vue&type=script&lang=js"
export * from "./PackagePage.vue?vue&type=script&lang=js"

import "./PackagePage.vue?vue&type=style&index=0&id=209206fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209206fa"]])

export default __exports__